// areaSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IArea, IAreaInitialState } from "./areaModal";
import {
  activeInactiveArea,
  createArea,
  deleteArea,
  getAllActiveAreas,
  getAllAreas,
  getAreaByID,
  areaImageUpload,
  updateArea,
} from "./services/area.service";

const initialState: IAreaInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  AreaID: null,
  AreaList: [],
  AreaDetail: {
    ID: null,
    Title: "",
    ShortDescription: "",
    IsDisplayInHome: false,
    SequenceNo: 0,
    CityID: 0,
    CityName: "",
    StateID: 0,
    StateName: "",
    ImageUpload: "",
    IsActive: 1,
  },
};

const areaSlice = createSlice({
  name: "area",
  initialState,
  reducers: {
    clearAreaDetails: (state) => {
      state.AreaDetail = initialState.AreaDetail;
    },
    setAreaID: (state, action) => {
      state.AreaID = action.payload;
    },
    clearAreaID: (state) => {
      state.AreaID = initialState.AreaID;
    },
  },
  extraReducers: (builder) => {
    // Get All Areas
    builder.addCase(getAllAreas.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllAreas.fulfilled,
      (state, action: PayloadAction<IArea[]>) => {
        state.loading = false;
        state.AreaList = action.payload || [];
      },
    );
    builder.addCase(getAllAreas.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.AreaList = [];
    });

    // Create Area
    builder.addCase(createArea.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createArea.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createArea.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Update Area
    builder.addCase(updateArea.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateArea.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateArea.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Delete Area
    builder.addCase(deleteArea.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteArea.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteArea.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Get Area By ID
    builder.addCase(getAreaByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getAreaByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.AreaDetail = action.payload;
    });
    builder.addCase(getAreaByID.rejected, (state, action) => {
      state.formLoading = false;
      state.AreaDetail = initialState.AreaDetail;
      state.error = action.error.message || "Something went wrong";
    });

    // Get All Active Areas
    builder.addCase(getAllActiveAreas.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveAreas.fulfilled,
      (state, action: PayloadAction<IArea[]>) => {
        state.loading = false;
        state.AreaList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveAreas.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.AreaList = [];
    });

    // Active/Inactive Area
    builder.addCase(activeInactiveArea.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(activeInactiveArea.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(activeInactiveArea.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Image Upload
    builder.addCase(areaImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(areaImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(areaImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearAreaDetails, clearAreaID, setAreaID } = areaSlice.actions;
export default areaSlice.reducer;
